import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { processPayment } from "apis/booking.api";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const bookingId = searchParams.get("bookingId");
    const amount = Number(searchParams.get("amount"));

    // 포트원 방식 (paymentId)
    const portonePaymentId = searchParams.get("paymentId");
    // 토스 방식 (paymentKey + orderId)
    const paymentKey = searchParams.get("paymentKey");
    const orderId = searchParams.get("orderId");

    if (!bookingId || !amount) {
      setStatus("error");
      setMessage("결제 정보가 올바르지 않습니다.");
      return;
    }

    if (portonePaymentId) {
      // 포트원 결제 승인 요청
      processPayment(bookingId, portonePaymentId, portonePaymentId, amount)
        .then(() => {
          setStatus("success");
          setMessage("결제가 완료되었습니다!");
        })
        .catch((err) => {
          setStatus("error");
          setMessage(err?.response?.data?.message || "결제 승인 중 오류가 발생했습니다.");
        });
    } else if (paymentKey && orderId) {
      // 토스 결제 승인 요청
      processPayment(bookingId, paymentKey, orderId, amount)
        .then(() => {
          setStatus("success");
          setMessage("결제가 완료되었습니다!");
        })
        .catch((err) => {
          setStatus("error");
          setMessage(err?.response?.data?.message || "결제 승인 중 오류가 발생했습니다.");
        });
    } else {
      setStatus("error");
      setMessage("결제 정보가 올바르지 않습니다.");
    }
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-achromatic-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        {status === "loading" && (
          <>
            <div className="text-5xl mb-4 animate-pulse">💳</div>
            <h2 className="text-xl font-bold text-achromatic-900 mb-2">
              결제 확인 중
            </h2>
            <p className="text-sm text-achromatic-500">잠시만 기다려주세요...</p>
          </>
        )}
        {status === "success" && (
          <>
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-xl font-bold text-achromatic-900 mb-2">
              {message}
            </h2>
            <p className="text-sm text-achromatic-500 mb-6">
              예약이 확정되었습니다. 알림톡을 확인해주세요.
            </p>
            <button
              onClick={() => navigate("/mypage/bookings")}
              className="w-full py-3 rounded-xl text-sm font-bold text-white bg-primary-500 hover:bg-primary-600 transition-colors"
            >
              예약 내역 보기
            </button>
          </>
        )}
        {status === "error" && (
          <>
            <div className="text-5xl mb-4">❌</div>
            <h2 className="text-xl font-bold text-red-500 mb-2">결제 실패</h2>
            <p className="text-sm text-achromatic-500 mb-6">{message}</p>
            <button
              onClick={() => navigate(-1)}
              className="w-full py-3 rounded-xl text-sm font-bold text-white bg-achromatic-700 hover:bg-achromatic-800 transition-colors"
            >
              돌아가기
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
